import { fetchData, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type CashRegisterParameters = {
  limit?: number;
  page?: number;
};

export type CashRegister = {
  active: boolean;
  count_order_for_24_hours: number;
  ern: number;
  ern_rub: number;
  id: string;
  name: string;
  pay_in_turnover_rub: number;
  pay_in_turnover_usdt: number;
  pay_out_turnover_rub: number;
  pay_out_turnover_usdt: number;
};

export type CashRegistersResponse<T = CashRegister> = PaginationResponse<{
  caches: T[];
}>;

export const getCashRegistersApi = async <T = CashRegister>(
  userId: string,
  data?: CashRegisterParameters
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<CashRegistersResponse<T>>({
      url: `api/v1/merchant/cashes/${userId}?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getCashRegistersApi failed:", error);
    throw error;
  }
};
